import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q17 = ({ history }) => {
  const { t } = useTranslation();
  const Q17Options = useMemo(
    () => [
      {
        id: 0,
        name: t('frequently'),
        value: 'frequently',
      },
      {
        id: 1,
        name: t('rarely'),
        value: 'rarely',
      },
      {
        id: 2,
        name: t('no'),
        value: 'no',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question17')}
      options={Q17Options}
      nextUrl="q18"
      screenName="q17"
    />
  );
};

export default Q17;
